import styled from '@emotion/styled';

import COLOR from '../../../../shared/constant/colorset';

const List = styled.ul<{ pageType?: string }>`
  padding: ${({ pageType }) => (pageType === 'mypage' ? '22px 0 40px 3px' : '20px 0 40px 3px')};
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: ${COLOR.kurlyGray600};
`;

const Item = styled.li`
  position: relative;
  padding-left: 11px;
  font-weight: 400;
  color: ${COLOR.kurlyGray450};
  ::before {
    content: '•';
    position: absolute;
    left: 1px;
    top: -1px;
    display: inline-block;
    font-size: 10px;
  }
  :first-of-type {
    padding-left: 0;
    font-weight: 500;
    color: ${COLOR.kurlyGray600};

    :before {
      display: none;
    }
  }
`;

interface Props {
  pageType?: string;
}

export default function ReviewBenefitNotice({ pageType }: Props) {
  return (
    <List pageType={pageType}>
      <Item>사진후기 100원, 글후기 50원 적립금 혜택이 있어요.</Item>
      <Item>퍼플, 더퍼플은 2배 적립 (사진 200원, 글 100원) / 주간 베스트 후기로 선정 시 5,000원을 추가 적립</Item>
      <Item>후기 작성은 배송완료일로부터 30일 이내 가능합니다.</Item>
      <Item>작성하신 후기는 확인 후 적립금이 지급됩니다. (영업일 기준 평균 1~2일 소요)</Item>
    </List>
  );
}
